var items = {
  "block.minecraft.air": "טֿפול",
  "block.minecraft.stone": "ןייטש",
  "block.minecraft.granite": "טינארג",
  "block.minecraft.polished_granite": "טינארג רעטרילאּפ",
  "block.minecraft.diorite": "טיגאיד",
  "block.minecraft.polished_diorite": "טיגאיד רעטרילאּפ",
  "block.minecraft.andesite": "טיזעדנא",
  "block.minecraft.polished_andesite": "טיזעדנא רעטרילאּפ",
  "block.minecraft.grass_block": "קאלבזארג",
  "block.minecraft.dirt": "דרע",
  "block.minecraft.coarse_dirt": "דרע עבארג",
  "block.minecraft.podzol": "ןדאבשא",
  "block.minecraft.crimson_nylium": "םוילינ ןסמאפ",
  "block.minecraft.warped_nylium": "םוילינ טשימעצ",
  "block.minecraft.cobblestone": "קורב",
  "block.minecraft.oak_planks": "רעטערבצלאהנכייא",
  "block.minecraft.spruce_planks": "רעטערבצלאהנענעט",
  "block.minecraft.birch_planks": "רעטערבצלאהעזערעב",
  "block.minecraft.jungle_planks": "רעטערבצלאהלגנושז",
  "block.minecraft.acacia_planks": "רעטערבצלאהנעיצאקא",
  "block.minecraft.dark_oak_planks": "רעטערבצלאהנכייצראווש",
  "block.minecraft.crimson_planks": "זדראב ןסמאפ",
  "block.minecraft.warped_planks": "זדראב טשימעצ",
  "block.minecraft.oak_sapling": "גנילצעזנכייא",
  "block.minecraft.spruce_sapling": "גנילצעזנענעט",
  "block.minecraft.birch_sapling": "גנילצעזעזערעב",
  "block.minecraft.jungle_sapling": "גנילצעזלגנושז",
  "block.minecraft.acacia_sapling": "גנילצעזהנעיצאקא",
  "block.minecraft.dark_oak_sapling": "גנילצעזנכייצראווש",
  "block.minecraft.bedrock": "ןייטשטנורגֿפיט",
  "block.minecraft.sand": "דמאז",
  "block.minecraft.red_sand": "דמאז רעטיור",
  "block.minecraft.gravel": "ריוושז",
  "block.minecraft.gold_ore": "ץראדלאג",
  "block.minecraft.iron_ore": "ץראנזַייא",
  "block.minecraft.coal_ore": "ליוקנייטש",
  "block.minecraft.nether_gold_ore": "רא דלאג רעהטענ",
  "block.minecraft.oak_log": "םאטשנכייא",
  "block.minecraft.spruce_log": "םאטשנענעט",
  "block.minecraft.birch_log": "םאטשעזערעב",
  "block.minecraft.jungle_log": "םאטשלגנושז",
  "block.minecraft.acacia_log": "םאטשנעיצאקא",
  "block.minecraft.dark_oak_log": "םאטשנכייצראווש",
  "block.minecraft.crimson_stem": "םאטש־ןסמאּפ",
  "block.minecraft.warped_stem": "םעטס טשימעצ",
  "block.minecraft.stripped_oak_log": "םאטשנכייא רעטליישעג",
  "block.minecraft.stripped_spruce_log": "םאטשנענעט רעטליישעג",
  "block.minecraft.stripped_birch_log": "םאטשעזערעב רעטליישעג",
  "block.minecraft.stripped_jungle_log": "םאטשלגנושז רעטליישעג",
  "block.minecraft.stripped_acacia_log": "םאטשנעיצאקא רעטליישעג",
  "block.minecraft.stripped_dark_oak_log": "םאטשנכייצראווש רעטליישעג",
  "block.minecraft.stripped_crimson_stem": "םעטס ןסמאפ טפירטס",
  "block.minecraft.stripped_warped_stem": "םעטס טשימעצ טפירטס",
  "block.minecraft.stripped_oak_wood": "ץלאהנכייא רעטליישעג",
  "block.minecraft.stripped_spruce_wood": "ץלאהנענעט רעטליישעג",
  "block.minecraft.stripped_birch_wood": "ץלאהעזערעב רעטליישעג",
  "block.minecraft.stripped_jungle_wood": "ץלאהלגנושז רעטליישעג",
  "block.minecraft.stripped_acacia_wood": "ץלאהנעיצאקא רעטליישעג",
  "block.minecraft.stripped_dark_oak_wood": "ץלאהנכייצראווש רעטליישעג",
  "block.minecraft.stripped_crimson_hyphae": "אפיה ןסמאפ טפירטס",
  "block.minecraft.stripped_warped_hyphae": "אפיה טשימעצ טפירטס",
  "block.minecraft.oak_wood": "ץלאהנכייא",
  "block.minecraft.spruce_wood": "ץלאהנענעט",
  "block.minecraft.birch_wood": "ץלאהעזערעב",
  "block.minecraft.jungle_wood": "ץלאהלגנושז",
  "block.minecraft.acacia_wood": "ץלאהנעיצאקא",
  "block.minecraft.dark_oak_wood": "ץלאהנכייצראווש",
  "block.minecraft.crimson_hyphae": "אפיה ןסמאפ",
  "block.minecraft.warped_hyphae": "אפיה טשימעצ",
  "block.minecraft.oak_leaves": "רעטעלבנכייא",
  "block.minecraft.spruce_leaves": "רעטעלבנענעט",
  "block.minecraft.birch_leaves": "רעטעלבעזערעב",
  "block.minecraft.jungle_leaves": "רעטעלבלגנושז",
  "block.minecraft.acacia_leaves": "רעטעלבנעיצאקא",
  "block.minecraft.dark_oak_leaves": "רעטעלבנכייצראווש",
  "block.minecraft.sponge": "םאווש",
  "block.minecraft.wet_sponge": "םאווש רעסאנ",
  "block.minecraft.glass": "זאלג",
  "block.minecraft.lapis_ore": "ץראנייטשאלב",
  "block.minecraft.lapis_block": "קאלבנייטשאלב",
  "block.minecraft.dispenser": "רעבעגעצ",
  "block.minecraft.sandstone": "ןייטשדמאז",
  "block.minecraft.chiseled_sandstone": "ןייטשדמאז רעטריווארג",
  "block.minecraft.cut_sandstone": "ןייטשדמאז רענטינשעג",
  "block.minecraft.note_block": "קאלבנטאנ",
  "block.minecraft.powered_rail": "עבארדסבירטנא",
  "block.minecraft.detector_rail": "עבארדראסנעס",
  "block.minecraft.sticky_piston": "עבלאק עקיּפעלק",
  "block.minecraft.cobweb": "עניטעוואפ",
  "block.minecraft.grass": "זארג",
  "block.minecraft.fern": "זארגרעדעֿפ",
  "block.minecraft.dead_bush": "טסוק רעטיוט",
  "block.minecraft.seagrass": "זארג־םי",
  "block.minecraft.sea_pickle": "עקרעגו־םי",
  "block.minecraft.piston": "עבלאק",
  "block.minecraft.white_wool": "לאוו עסַייוו",
  "block.minecraft.orange_wool": "לאוו עשזנארא",
  "block.minecraft.magenta_wool": "לאוו עאטנעשזדאמ",
  "block.minecraft.light_blue_wool": "לאוו עיולבלעה",
  "block.minecraft.yellow_wool": "לאוו עלעג",
  "block.minecraft.lime_wool": "לאוו ענירגלעה",
  "block.minecraft.pink_wool": "לאוו עטיורלעה",
  "block.minecraft.gray_wool": "לאוו עיורג",
  "block.minecraft.light_gray_wool": "לאוו עיורגלעה",
  "block.minecraft.cyan_wool": "לאוו עסיקרוט",
  "block.minecraft.purple_wool": "לאוו עאליל",
  "block.minecraft.blue_wool": "לאוו עיולב",
  "block.minecraft.brown_wool": "לאוו עניורב",
  "block.minecraft.green_wool": "לאוו ענירג",
  "block.minecraft.red_wool": "לאוו עטיור",
  "block.minecraft.black_wool": "לאוו עצראווש",
  "block.minecraft.dandelion": "לטפול",
  "block.minecraft.poppy": "ןאמ",
  "block.minecraft.blue_orchid": "עיידיכרא עיולב",
  "block.minecraft.allium": "עלעביצ־עראּפ",
  "block.minecraft.azure_bluet": "לדנרעטשנאלעצראּפ",
  "block.minecraft.red_tulip": "עּפלוט עטיור",
  "block.minecraft.orange_tulip": "עּפלוט עשזנארא",
  "block.minecraft.white_tulip": "עּפלוט עסַייוו",
  "block.minecraft.pink_tulip": "עּפלוטעטיורלעה",
  "block.minecraft.oxeye_daisy": "עטירעגראמ",
  "block.minecraft.cornflower": "למילבנראק",
  "block.minecraft.lily_of_the_valley": "לקעלגיימ",
  "block.minecraft.wither_rose": "זיור־רעדיוו",
  "block.minecraft.brown_mushroom": "למעוושניורב",
  "block.minecraft.red_mushroom": "למעוושטיור",
  "block.minecraft.crimson_fungus": "למעווש ןסמאפ",
  "block.minecraft.warped_fungus": "למעווש טשימעצ",
  "block.minecraft.crimson_roots": "לצראוו ןסמאפ",
  "block.minecraft.warped_roots": "לצראוו טשימעצ",
  "block.minecraft.nether_sprouts": "ץוארּפס רעהטענ",
  "block.minecraft.weeping_vines": "קאטשנייוו ןענייוו",
  "block.minecraft.twisting_vines": "קאטשנייוו גניטסיווט",
  "block.minecraft.sugar_cane": "ראררעקוצ",
  "block.minecraft.kelp": "זארג־םי",
  "block.minecraft.bamboo": "קובמאב",
  "block.minecraft.gold_block": "קאלבדלאג",
  "block.minecraft.iron_block": "קאלבנזַייא",
  "block.minecraft.oak_slab": "עטאלּפצלאהנכייא",
  "block.minecraft.spruce_slab": "עטאלּפצלאהנענעט",
  "block.minecraft.birch_slab": "עטאלּפצלאהעזערעב",
  "block.minecraft.jungle_slab": "עטאלּפצלאהלגנושז",
  "block.minecraft.acacia_slab": "עטאלּפצלאהנעיצאקא",
  "block.minecraft.dark_oak_slab": "עטאלּפצלאהנכייצראווש",
  "block.minecraft.crimson_slab": "עטאלפ ןסמאפ",
  "block.minecraft.warped_slab": "עטאלפ טשימעצ",
  "block.minecraft.stone_slab": "עטאלּפנייטש",
  "block.minecraft.smooth_stone_slab": "עטאלּפנייטש עטאלג",
  "block.minecraft.sandstone_slab": "עטאלּפנייטשדמאז",
  "block.minecraft.cut_sandstone_slab": "עטאלּפנייטשדמאז ענטינשעג",
  "block.minecraft.petrified_oak_slab": "עטאלּפצלאהנכַייא עטרענייטשראֿפ",
  "block.minecraft.cobblestone_slab": "עטאלּפקורב",
  "block.minecraft.brick_slab": "עטאלּפנייטשלגיצ",
  "block.minecraft.stone_brick_slab": "עטאלּפלגיצנייטש",
  "block.minecraft.nether_brick_slab": "עטאלּפלגיצרעדענ",
  "block.minecraft.quartz_slab": "עטאלּפצראווק",
  "block.minecraft.red_sandstone_slab": "עטאלּפנייטשדמאזטיור",
  "block.minecraft.cut_red_sandstone_slab": "עטאלפנןייטשדמאז עטיור ענטינשעג",
  "block.minecraft.purpur_slab": "עטאלפרופרופ",
  "block.minecraft.prismarine_slab": "עטאלּפניראמסירּפ",
  "block.minecraft.prismarine_brick_slab": "עטאלּפלגיצניראמסירּפ",
  "block.minecraft.dark_prismarine_slab": "עטאלּפניראמסירּפלקנוט",
  "block.minecraft.smooth_quartz": "עטאלפצראווק עטאלג",
  "block.minecraft.smooth_red_sandstone": "ןייטשגמאזטיור רעטאלג",
  "block.minecraft.smooth_sandstone": "ןייטשגמאז רעטאלג",
  "block.minecraft.smooth_stone": "ןייטש רעטאלג",
  "block.minecraft.bricks": "רענייטשלגיצ",
  "block.minecraft.tnt": "טימאניד",
  "block.minecraft.bookshelf": "קנעשרעכיב",
  "block.minecraft.mossy_cobblestone": "קורב רעטכאמאב",
  "block.minecraft.obsidian": "ןאידיסבא",
  "block.minecraft.torch": "לקאֿפ",
  "block.minecraft.end_rod": "באטשדנע",
  "block.minecraft.chorus_plant": "טיורקראכ",
  "block.minecraft.chorus_flower": "םולבראכ",
  "block.minecraft.purpur_block": "קאלברופרופ",
  "block.minecraft.purpur_pillar": "לייצרופרופ",
  "block.minecraft.purpur_stairs": "ףערטרופרופ",
  "block.minecraft.spawner": "רענאּפס",
  "block.minecraft.oak_stairs": "ףפערטצלאהנכייא",
  "block.minecraft.chest": "ןטסאק",
  "block.minecraft.diamond_ore": "ץראטנעמיד",
  "block.minecraft.diamond_block": "קאלבטנעמיד",
  "block.minecraft.crafting_table": "קנאבקרעוו",
  "block.minecraft.farmland": "ןדאברעקא",
  "block.minecraft.furnace": "ןוויוא",
  "block.minecraft.ladder": "רעטייל",
  "block.minecraft.rail": "עבארד",
  "block.minecraft.cobblestone_stairs": "ףערטקורב",
  "block.minecraft.lever": "לבייה",
  "block.minecraft.stone_pressure_plate": "עטאלפקורדנייטש",
  "block.minecraft.oak_pressure_plate": "עטאלּפקורדצלאהנכייא",
  "block.minecraft.spruce_pressure_plate": "עטאלּפקורדצלאהנענעט",
  "block.minecraft.birch_pressure_plate": "עטאלּפקורדצלאהעזערעב",
  "block.minecraft.jungle_pressure_plate": "עטאלּפקורדצלאהלגנושז",
  "block.minecraft.acacia_pressure_plate": "עטאלּפקורדצלאהנעיצאקא",
  "block.minecraft.dark_oak_pressure_plate": "עטאלּפקורדצלאהנכייצראווש",
  "block.minecraft.crimson_pressure_plate": "עטאלפקורד ןסמאפ",
  "block.minecraft.warped_pressure_plate": "עטאלפקורד טשימעצ",
  "block.minecraft.polished_blackstone_pressure_plate": "עטאלפקורדנייטשצראווש טשילאפ",
  "block.minecraft.redstone_ore": "ץרא־ןאטסדער",
  "block.minecraft.redstone_torch": "לקאֿפ־ןאטסדער",
  "block.minecraft.snow": "יינש",
  "block.minecraft.ice": "זַייא",
  "block.minecraft.snow_block": "קאלביינש",
  "block.minecraft.cactus": "סוטקאק",
  "block.minecraft.clay": "קאלבמייל",
  "block.minecraft.jukebox": "טאמאקיזומ",
  "block.minecraft.oak_fence": "םיוצצלאהנכייא",
  "block.minecraft.spruce_fence": "םיוצצלאהנענעט",
  "block.minecraft.birch_fence": "םיוצצלאהעזערעב",
  "block.minecraft.jungle_fence": "םיוצצלאהלגנושז",
  "block.minecraft.acacia_fence": "םיוצצלאהנעיצאקא",
  "block.minecraft.dark_oak_fence": "םיוצצלאהנכייצראווש",
  "block.minecraft.crimson_fence": "טיולפ ןסמאפ",
  "block.minecraft.warped_fence": "טיולפ טשימעצ",
  "block.minecraft.pumpkin": "סעבריק",
  "block.minecraft.carved_pumpkin": "סעבריק רעצינשעג",
  "block.minecraft.netherrack": "קאררעדענ",
  "block.minecraft.soul_sand": "דמאזנלעז",
  "block.minecraft.soul_soil": "ןדאב המשנ",
  "block.minecraft.basalt": "טלאזאב",
  "block.minecraft.polished_basalt": "טלאזאב טשילאפ",
  "block.minecraft.soul_torch": "שטראט המשנ",
  "block.minecraft.glowstone": "ןייטשטכַייל",
  "block.minecraft.jack_o_lantern": "ןרעטמאלסעבריק",
  "block.minecraft.oak_trapdoor": "ריטלאֿפצלאהנכייא",
  "block.minecraft.spruce_trapdoor": "ריטלאֿפצלאהנענעט",
  "block.minecraft.birch_trapdoor": "ריטלאֿפצלאהעזערעב",
  "block.minecraft.jungle_trapdoor": "ריטלאֿפצלאהלגנושז",
  "block.minecraft.acacia_trapdoor": "ריטלאֿפצלאהנעיצאקא",
  "block.minecraft.dark_oak_trapdoor": "ריטלאֿפצלאהנכייצראווש",
  "block.minecraft.crimson_trapdoor": "ריט פארט עטאלפ",
  "block.minecraft.warped_trapdoor": "ריט פארט טשימעצ",
  "block.minecraft.infested_stone": "ןייטש רעטצרשראֿפ",
  "block.minecraft.infested_cobblestone": "קורב רעטצרשראֿפ",
  "block.minecraft.infested_stone_bricks": "לגיצנייטש עטצרשראֿפ",
  "block.minecraft.infested_mossy_stone_bricks": "לגיצנייטש עטכאמאב עטצרשראֿפ",
  "block.minecraft.infested_cracked_stone_bricks": "לגיצנייטש עקיסיר עטצרשראֿפ",
  "block.minecraft.infested_chiseled_stone_bricks": "לגיצנייטש עטריווארג עטצרשראֿפ",
  "block.minecraft.stone_bricks": "לגיצנייטש",
  "block.minecraft.mossy_stone_bricks": "לגיצנייטש עטכאמאב",
  "block.minecraft.cracked_stone_bricks": "לגיצנייטש עקיסיר",
  "block.minecraft.chiseled_stone_bricks": "לגיצנייטש עטריווארג",
  "block.minecraft.brown_mushroom_block": "קאלבלמעוושניורב",
  "block.minecraft.red_mushroom_block": "קאלבלמעוושטיור",
  "block.minecraft.mushroom_stem": "םאטשלמעווש",
  "block.minecraft.iron_bars": "ןגנאטשנזַייא",
  "block.minecraft.chain": "ןלטייקראפ",
  "block.minecraft.glass_pane": "לרעזעלב",
  "block.minecraft.melon": "ענעוואק",
  "block.minecraft.vine": "טיורקרערעטעלק",
  "block.minecraft.oak_fence_gate": "רעיוטמיוצצלאהנכייא",
  "block.minecraft.spruce_fence_gate": "רעיוטמיוצצלאהנענעט",
  "block.minecraft.birch_fence_gate": "רעיוטמיוצצלאהעזערעב",
  "block.minecraft.jungle_fence_gate": "רעיוטמיוצצלאהלגנושז",
  "block.minecraft.acacia_fence_gate": "רעיוטמיוצצלאהנעיצאקא",
  "block.minecraft.dark_oak_fence_gate": "רעיוטמיוצצלאהנכייצראווש",
  "block.minecraft.crimson_fence_gate": "רעיוט טיולפ ןסמאפ",
  "block.minecraft.warped_fence_gate": "רעיוט טיולפ טשימעצ",
  "block.minecraft.brick_stairs": "ףערנייטשטלגיצ",
  "block.minecraft.stone_brick_stairs": "ףערטלגיצנייטש",
  "block.minecraft.mycelium": "לעצימ",
  "block.minecraft.lily_pad": "קאלבזיור־םי",
  "block.minecraft.nether_bricks": "לגיצ־רעדענ",
  "block.minecraft.cracked_nether_bricks": "לגיצרעדענ עקיסיר",
  "block.minecraft.chiseled_nether_bricks": "לגיצרעדענ עטריווארג",
  "block.minecraft.nether_brick_fence": "םיוצלגיצ־רעדענ",
  "block.minecraft.nether_brick_stairs": "ףכרטלגיצ־רעדענ",
  "block.minecraft.enchanting_table": "שיטרעביוצ",
  "block.minecraft.end_portal_frame": "םארלאטראּפדנע",
  "block.minecraft.end_stone": "ןייטשדנע",
  "block.minecraft.end_stone_bricks": "לגיצנייטשדנע",
  "block.minecraft.dragon_egg": "יינאקארד",
  "block.minecraft.redstone_lamp": "ףמאל־נאטסדער",
  "block.minecraft.sandstone_stairs": "ףערטנייטשדמאז",
  "block.minecraft.emerald_ore": "ץראקאראמש",
  "block.minecraft.ender_chest": "ןטסאקרעדנע",
  "block.minecraft.tripwire_hook": "ןקאהטארדלשכינ",
  "block.minecraft.emerald_block": "קאלבקאראמש",
  "block.minecraft.spruce_stairs": "ףפערטצלאהנענעט",
  "block.minecraft.birch_stairs": "ףערטצלאהעזערעב",
  "block.minecraft.jungle_stairs": "ףערטצלאהלגנושז",
  "block.minecraft.crimson_stairs": "פערט עטאלפ",
  "block.minecraft.warped_stairs": "פערט טשימעצ",
  "block.minecraft.command_block": "קאלבסלעֿפאב",
  "block.minecraft.beacon": "רעַייֿפטכַייל",
  "block.minecraft.cobblestone_wall": "רעיומקורב",
  "block.minecraft.mossy_cobblestone_wall": "רעיומקורב עטכאמאב",
  "block.minecraft.brick_wall": "רעיומנייטשלגיצ",
  "block.minecraft.prismarine_wall": "רעיומניראמסירּפ",
  "block.minecraft.red_sandstone_wall": "רעיומנייטשדמאז עטיור",
  "block.minecraft.mossy_stone_brick_wall": "רעיומלגיצנייטש עטכאמאב",
  "block.minecraft.granite_wall": "רעיומטינארג",
  "block.minecraft.stone_brick_wall": "רעיומלגיצנייטש",
  "block.minecraft.nether_brick_wall": "רעיומלגיצרעדענ",
  "block.minecraft.andesite_wall": "רעיומטיזעדנא",
  "block.minecraft.red_nether_brick_wall": "רעיומלגיצרעדענ עטיור",
  "block.minecraft.sandstone_wall": "רעיומנייטשדמאז",
  "block.minecraft.end_stone_brick_wall": "רעיומלגיצנייטשדנע",
  "block.minecraft.diorite_wall": "רעייומטיגאיד",
  "block.minecraft.blackstone_wall": "רעיומנייטשצראווש",
  "block.minecraft.polished_blackstone_wall": "רעיומנייטשצראווש טשילאפ",
  "block.minecraft.polished_blackstone_brick_wall": "רעיומלגיצנייטשצראווש טשילאפ",
  "block.minecraft.stone_button": "ףאנקנייטש",
  "block.minecraft.oak_button": "ףאנקצלאהנכייא",
  "block.minecraft.spruce_button": "ףאנקצלאהנענעט",
  "block.minecraft.birch_button": "ףאנקצלאהעזערעב",
  "block.minecraft.jungle_button": "ףאנקצלאהלגנושז",
  "block.minecraft.acacia_button": "ףאנקצלאהנעיצאקא",
  "block.minecraft.dark_oak_button": "ףאנקצלאהנכייצראווש",
  "block.minecraft.crimson_button": "לפענק עטאלפ",
  "block.minecraft.warped_button": "לּפענק טשימעצ",
  "block.minecraft.polished_blackstone_button": "לפענקלגיצנייטשצראווש טשילאפ",
  "block.minecraft.anvil": "לוטשנא",
  "block.minecraft.chipped_anvil": "לוטשנא רענגאלשעגנא",
  "block.minecraft.damaged_anvil": "לוטשנא רעטקידעשאב",
  "block.minecraft.trapped_chest": "ןטסאקּפאכ",
  "block.minecraft.light_weighted_pressure_plate": "עטאלּפקורדטכיוועגנַייֿפ",
  "block.minecraft.heavy_weighted_pressure_plate": "עטאלּפקורדטכיוועגבארג",
  "block.minecraft.daylight_detector": "ראסנעססטכילגאט",
  "block.minecraft.redstone_block": "קאלב־נאטסדער",
  "block.minecraft.nether_quartz_ore": "ץראצראווק־רעדענ",
  "block.minecraft.hopper": "עקייל",
  "block.minecraft.chiseled_quartz_block": "קאלבצראווק רעטריווארג",
  "block.minecraft.quartz_block": "קאלבצראווק",
  "block.minecraft.quartz_bricks": "לגיצצראווק",
  "block.minecraft.quartz_pillar": "לַייזצראווק",
  "block.minecraft.quartz_stairs": "ףערטצראווק",
  "block.minecraft.activator_rail": "עבארדגנוריוויטקא",
  "block.minecraft.dropper": "רעסיגראֿפ",
  "block.minecraft.white_terracotta": "קימארעק עסַייוו",
  "block.minecraft.orange_terracotta": "קימארעק עשזנארא",
  "block.minecraft.magenta_terracotta": "קימארעק עאטנעשזדאמ",
  "block.minecraft.light_blue_terracotta": "קימארעק עיולבלעה",
  "block.minecraft.yellow_terracotta": "קימארעק עלעג",
  "block.minecraft.lime_terracotta": "קימארעק ענירגלעה",
  "block.minecraft.pink_terracotta": "קימארעק עטיורלעה",
  "block.minecraft.gray_terracotta": "קימארעק עיורג",
  "block.minecraft.light_gray_terracotta": "קימארעק עיורגלעה",
  "block.minecraft.cyan_terracotta": "קימארעק עזיקרוט",
  "block.minecraft.purple_terracotta": "קימארעק עאליל",
  "block.minecraft.blue_terracotta": "קימארעק עיולב",
  "block.minecraft.brown_terracotta": "קימארעק עניורב",
  "block.minecraft.green_terracotta": "קימארעק ענירג",
  "block.minecraft.red_terracotta": "קימארעק עטיור",
  "block.minecraft.black_terracotta": "קימארעק עראווש",
  "block.minecraft.barrier": "רעיראב",
  "block.minecraft.iron_trapdoor": "ריטלאֿפנזַייא",
  "block.minecraft.hay_block": "ןלאביורטש",
  "block.minecraft.white_carpet": "ךעּפעט רעסַייוו",
  "block.minecraft.orange_carpet": "ךעּפעט רעשזנארא",
  "block.minecraft.magenta_carpet": "ךעּפעט רעאטנעשזדאמ",
  "block.minecraft.light_blue_carpet": "ךעּפעט רעיולבלעה",
  "block.minecraft.yellow_carpet": "ךעּפעט רעלעג",
  "block.minecraft.lime_carpet": "ךעּפעט רענירגלעה",
  "block.minecraft.pink_carpet": "ךעּפעט רעטיורלעה",
  "block.minecraft.gray_carpet": "ךעּפעט רעיורג",
  "block.minecraft.light_gray_carpet": "ךעּפעט רעיורגלעה",
  "block.minecraft.cyan_carpet": "ךעּפעט רעזיקרוט",
  "block.minecraft.purple_carpet": "ךעּפעט רעאליל",
  "block.minecraft.blue_carpet": "ךעּפעט רעיולב",
  "block.minecraft.brown_carpet": "ךעּפעט רעניורב",
  "block.minecraft.green_carpet": "ךעּפעט רענירג",
  "block.minecraft.red_carpet": "ךעּפעט רעטיור",
  "block.minecraft.black_carpet": "ךעּפעט רעצראווש",
  "block.minecraft.terracotta": "קימארעק",
  "block.minecraft.coal_block": "קאלבליוק",
  "block.minecraft.packed_ice": "זַייקאּפ",
  "block.minecraft.acacia_stairs": "ףערטצלאהנעיצאקא",
  "block.minecraft.dark_oak_stairs": "ףערטצלאהנכייצראווש",
  "block.minecraft.slime_block": "קאלבמיילש",
  "block.minecraft.grass_path": "געווזארג",
  "block.minecraft.sunflower": "קינשינאס",
  "block.minecraft.lilac": "זעב",
  "block.minecraft.rose_bush": "עקאשקנזיור",
  "block.minecraft.peony": "ןאיּפ",
  "block.minecraft.tall_grass": "זארגךיוה",
  "block.minecraft.large_fern": "זארגרעדעֿפ ססיורג",
  "block.minecraft.white_stained_glass": "זאלג סטבראֿפעגסַייוו",
  "block.minecraft.orange_stained_glass": "זאלג סטבראֿפעגשזנארא",
  "block.minecraft.magenta_stained_glass": "זאלג סטבראֿפעגאטנעשזדאמ",
  "block.minecraft.light_blue_stained_glass": "זאלג סטבראֿפעגיולבלעה",
  "block.minecraft.yellow_stained_glass": "זאלג סטבראֿפעגלעג",
  "block.minecraft.lime_stained_glass": "זאלג סטבראֿפעגנירגלעה",
  "block.minecraft.pink_stained_glass": "זאלג סטבראֿפעגטיורלעה",
  "block.minecraft.gray_stained_glass": "זאלג סטבראֿפעגיורג",
  "block.minecraft.light_gray_stained_glass": "זאלג סטבראֿפעגיורגלעה",
  "block.minecraft.cyan_stained_glass": "זאלג סטבראֿפעגזיקרוט",
  "block.minecraft.purple_stained_glass": "זאלג סטבראֿפעגאליל",
  "block.minecraft.blue_stained_glass": "זאלג סטבראֿפעגיולב",
  "block.minecraft.brown_stained_glass": "זאלג סטבראֿפעגניורב",
  "block.minecraft.green_stained_glass": "זאלג סטבראֿפעגנירג",
  "block.minecraft.red_stained_glass": "זאלג סטבראֿפעגטיור",
  "block.minecraft.black_stained_glass": "זאלג סטבראֿפעגצראווש",
  "block.minecraft.white_stained_glass_pane": "ביושזאלג עטבראֿפעגסַייוו",
  "block.minecraft.orange_stained_glass_pane": "ביושזאלג עטבראֿפעגשזנארא",
  "block.minecraft.magenta_stained_glass_pane": "ביושזאלג עטבראֿפעגאטנעשזדאמ",
  "block.minecraft.light_blue_stained_glass_pane": "ביושזאלג עטבראֿפעגיולבלעה",
  "block.minecraft.yellow_stained_glass_pane": "ביושזאלג עטבראֿפעגלעג",
  "block.minecraft.lime_stained_glass_pane": "ביושזאלג עטבראֿפעגנירגלעה",
  "block.minecraft.pink_stained_glass_pane": "ביושזאלג עטבראֿפעגטיורלעה",
  "block.minecraft.gray_stained_glass_pane": "ביושזאלג עטבראֿפעגיורג",
  "block.minecraft.light_gray_stained_glass_pane": "ביושזאלג עטבראֿפעגיורגלעה",
  "block.minecraft.cyan_stained_glass_pane": "ביושזאלג עטבראֿפעגזיקרוט",
  "block.minecraft.purple_stained_glass_pane": "ביושזאלג עטבראֿפעגאליל",
  "block.minecraft.blue_stained_glass_pane": "ביושזאלג עטבראֿפעגיולב",
  "block.minecraft.brown_stained_glass_pane": "ביושזאלג עטבראֿפעגניורב",
  "block.minecraft.green_stained_glass_pane": "ביושזאלג עטבראֿפעגנירג",
  "block.minecraft.red_stained_glass_pane": "ביושזאלג עטבראֿפעגטיור",
  "block.minecraft.black_stained_glass_pane": "ביושזאלג עטבראֿפעגצראווש",
  "block.minecraft.prismarine": "ןיראמסירּפ",
  "block.minecraft.prismarine_bricks": "לגיצניראמסירּפ",
  "block.minecraft.dark_prismarine": "ןיראמסירּפלקנוט",
  "block.minecraft.prismarine_stairs": "ףערטניראמסירּפ",
  "block.minecraft.prismarine_brick_stairs": "ףערטלגיצניראמסירּפ",
  "block.minecraft.dark_prismarine_stairs": "ףערטניראמסירּפלקנוט",
  "block.minecraft.sea_lantern": "ןרעטמאל־םי",
  "block.minecraft.red_sandstone": "ןייטשדמאז רעטיור",
  "block.minecraft.chiseled_red_sandstone": "ןייטשדמאז רעטיור רעטריווארג",
  "block.minecraft.cut_red_sandstone": "ןייטשדמאז רעטיור רענטינשעג",
  "block.minecraft.red_sandstone_stairs": "ףערטנייטשדמאזטיור",
  "block.minecraft.repeating_command_block": "קאלבסלעֿפאבסגנורזחרעביא",
  "block.minecraft.chain_command_block": "קאלבסלעֿפאבנטייק",
  "block.minecraft.magma_block": "קאלבעמגאמ",
  "block.minecraft.nether_wart_block": "קאלבסעקוועדארב־רעדענ",
  "block.minecraft.warped_wart_block": "קאלב עקוועדארב טשימעצ",
  "block.minecraft.red_nether_bricks": "לגיצ־רעדענ עטיור",
  "block.minecraft.bone_block": "קאלבנייב",
  "block.minecraft.structure_void": "םוהּת־רוטקורטס",
  "block.minecraft.observer": "רעבעגטכא",
  "block.minecraft.shulker_box": "עסאקרעקלוש",
  "block.minecraft.white_shulker_box": "עסאקרעקלוש עסייוו",
  "block.minecraft.orange_shulker_box": "עסאקרעקלוש עשזנארא",
  "block.minecraft.magenta_shulker_box": "עסאקרעקלוש עאטנעשזדאמ",
  "block.minecraft.light_blue_shulker_box": "עסאקרעקלוש עיולבלעה",
  "block.minecraft.yellow_shulker_box": "עסאקרעקלוש עלעג",
  "block.minecraft.lime_shulker_box": "עסאקרעקלוש ענירגלעה",
  "block.minecraft.pink_shulker_box": "עסאקרעקלוש עטיורלעה",
  "block.minecraft.gray_shulker_box": "עסאקרעקלוש עיורג",
  "block.minecraft.light_gray_shulker_box": "עסאקרעקלוש עיורגלעה",
  "block.minecraft.cyan_shulker_box": "עסאקרעקלוש עזיקרוט",
  "block.minecraft.purple_shulker_box": "עסאקרעקלוש עאליל",
  "block.minecraft.blue_shulker_box": "עסאקרעקלוש עיולב",
  "block.minecraft.brown_shulker_box": "עסאקרעקלוש עניורב",
  "block.minecraft.green_shulker_box": "עסאקרעקלוש ענירג",
  "block.minecraft.red_shulker_box": "עסאקרעקלוש עטיור",
  "block.minecraft.black_shulker_box": "עסאקרעקלוש עצראווש",
  "block.minecraft.white_glazed_terracotta": "קימארעק עטריזאלגסַייוו",
  "block.minecraft.orange_glazed_terracotta": "קימארעק עטריזאלגשזנארא",
  "block.minecraft.magenta_glazed_terracotta": "קימארעק עטריזאלגאטנעשזדאמ",
  "block.minecraft.light_blue_glazed_terracotta": "קימארעק עטריזאלגיולבלעה",
  "block.minecraft.yellow_glazed_terracotta": "קימארעק עטריזאלגלעג",
  "block.minecraft.lime_glazed_terracotta": "קימארעק עטריזאלגנירגלעה",
  "block.minecraft.pink_glazed_terracotta": "קימארעק עטריזאלגטיורלעה",
  "block.minecraft.gray_glazed_terracotta": "קימארעק עטריזאלגיורג",
  "block.minecraft.light_gray_glazed_terracotta": "קימארעק עטריזאלגיורגלעה",
  "block.minecraft.cyan_glazed_terracotta": "קימארעק עטריזאלגזיקרוט",
  "block.minecraft.purple_glazed_terracotta": "קימארעק עטריזאלגאליל",
  "block.minecraft.blue_glazed_terracotta": "קימארעק עטריזאלגיולב",
  "block.minecraft.brown_glazed_terracotta": "קימארעק עטריזאלגניורב",
  "block.minecraft.green_glazed_terracotta": "קימארעק עטריזאלגנירג",
  "block.minecraft.red_glazed_terracotta": "קימארעק עטריזאלגטיור",
  "block.minecraft.black_glazed_terracotta": "קימארעק עטריזאלגשראווש",
  "block.minecraft.white_concrete": "ןאטעבסַייוו",
  "block.minecraft.orange_concrete": "ןאטעבשזנארא",
  "block.minecraft.magenta_concrete": "ןאטעבאטנעשזדאמ",
  "block.minecraft.light_blue_concrete": "ןאטעביולבלעה",
  "block.minecraft.yellow_concrete": "ןאטעבלעג",
  "block.minecraft.lime_concrete": "ןאטעבנירגלעה",
  "block.minecraft.pink_concrete": "ןאטעבטיורלעה",
  "block.minecraft.gray_concrete": "ןאטעביורג",
  "block.minecraft.light_gray_concrete": "ןאטעביורגלעה",
  "block.minecraft.cyan_concrete": "ןאטעבזיקרוט",
  "block.minecraft.purple_concrete": "ןאטעבאליל",
  "block.minecraft.blue_concrete": "ןאטעביולב",
  "block.minecraft.brown_concrete": "ןאטעבניורב",
  "block.minecraft.green_concrete": "ןאטעבנירג",
  "block.minecraft.red_concrete": "ןאטעבטיור",
  "block.minecraft.black_concrete": "ןאטעבצראווש",
  "block.minecraft.white_concrete_powder": "רעוולופנאטעבסַייוו",
  "block.minecraft.orange_concrete_powder": "רעוולופנאטעבשזנארא",
  "block.minecraft.magenta_concrete_powder": "רעוולופנאטעבאטנעשזדאמ",
  "block.minecraft.light_blue_concrete_powder": "רעוולופנאטעביולבלעה",
  "block.minecraft.yellow_concrete_powder": "רעוולופנאטעבלעג",
  "block.minecraft.lime_concrete_powder": "רעוולופנאטעבנירגלעה",
  "block.minecraft.pink_concrete_powder": "רעוולופנאטעבטיורלעה",
  "block.minecraft.gray_concrete_powder": "רעוולופנאטעביורג",
  "block.minecraft.light_gray_concrete_powder": "רעוולופנאטעביורגלעה",
  "block.minecraft.cyan_concrete_powder": "רעוולופנאטעבזיקרוט",
  "block.minecraft.purple_concrete_powder": "רעוולופנאטעבאליל",
  "block.minecraft.blue_concrete_powder": "רעוולופנאטעביולב",
  "block.minecraft.brown_concrete_powder": "רעוולופנאטעבניורב",
  "block.minecraft.green_concrete_powder": "רעוולופנאטעבנירג",
  "block.minecraft.red_concrete_powder": "רעוולופנאטעבטיור",
  "block.minecraft.black_concrete_powder": "רעוולופנאטעבצראווש",
  "block.minecraft.turtle_egg": "יינטיורקדליש",
  "block.minecraft.dead_tube_coral_block": "קאלבנלאראקלגרא רענבראטשעגפא",
  "block.minecraft.dead_brain_coral_block": "קאלבנלאראקנריהעג רענבראטשעגפא",
  "block.minecraft.dead_bubble_coral_block": "קאלבנלאראקנזאלב רענבראטשעגפא",
  "block.minecraft.dead_fire_coral_block": "קאלבנלאראקרעייפ רענבראטשעגפא",
  "block.minecraft.dead_horn_coral_block": "קאלבנלאראקנראה רענבראטשעגפא",
  "block.minecraft.tube_coral_block": "קאלבנלאראקלגרא",
  "block.minecraft.brain_coral_block": "קאלבנלאראקנריהעג",
  "block.minecraft.bubble_coral_block": "קאלבנלאראקזאלב",
  "block.minecraft.fire_coral_block": "קאלבנלאראקרעַייֿפ",
  "block.minecraft.horn_coral_block": "קאלבנלאראקנראה",
  "block.minecraft.tube_coral": "אראקלגרא",
  "block.minecraft.brain_coral": "לאראקנריהעג",
  "block.minecraft.bubble_coral": "לאראקזאלב",
  "block.minecraft.fire_coral": "לאראקרעַייֿפ",
  "block.minecraft.horn_coral": "לאראקנראה",
  "block.minecraft.dead_brain_coral": "לאראקנריהעג רענבראטשעגפא",
  "block.minecraft.dead_bubble_coral": "לאראקנזאלב רענבראטשעגפא",
  "block.minecraft.dead_fire_coral": "לאראקרעייפ רענבראטשעגפא",
  "block.minecraft.dead_horn_coral": "לאראקנראה רענבראטשעגפא",
  "block.minecraft.dead_tube_coral": "לאראקלגרא רענבראטשעגפא",
  "block.minecraft.tube_coral_fan": "רעכעפנלאראקלגרא",
  "block.minecraft.brain_coral_fan": "רעכעפנלאראקנריהעג",
  "block.minecraft.bubble_coral_fan": "רעכעפנלאראקזאלב",
  "block.minecraft.fire_coral_fan": "רעכעפנלאראקרעַייֿפ",
  "block.minecraft.horn_coral_fan": "רעכעפנלאראקנראה",
  "block.minecraft.dead_tube_coral_fan": "רעכעפנלאראקלגרא רענבראטשעגפא",
  "block.minecraft.dead_brain_coral_fan": "רעכעפנלאראקנריהעג רענבראטשעגפא",
  "block.minecraft.dead_bubble_coral_fan": "רעכעפנלאראקזאלב רענבראטשעגפא",
  "block.minecraft.dead_fire_coral_fan": "רעכעפנלאראקרעַייֿפ רענבראטשעגפא",
  "block.minecraft.dead_horn_coral_fan": "רעכעפנלאראקנראה רענבראטשעגפא",
  "block.minecraft.blue_ice": "זַיייולב",
  "block.minecraft.conduit": "ראטאזיווקא",
  "block.minecraft.polished_granite_stairs": "פערטטינארג רעטרילאּפ",
  "block.minecraft.smooth_red_sandstone_stairs": "ףערטנייטשדמאזטיור עטאלג",
  "block.minecraft.mossy_stone_brick_stairs": "ףערטלגיצנייטש עטכאמאב",
  "block.minecraft.polished_diorite_stairs": "פערטטיגאיד רעטרילאּפ",
  "block.minecraft.mossy_cobblestone_stairs": "פערטקורב רעטכאמאב",
  "block.minecraft.end_stone_brick_stairs": "ףערטלגיצנייטשדנע",
  "block.minecraft.stone_stairs": "ףערטנייטש",
  "block.minecraft.smooth_sandstone_stairs": "ףערטנייטשדמאז עטאלג",
  "block.minecraft.smooth_quartz_stairs": "פערטצראווק רעטאלג",
  "block.minecraft.granite_stairs": "פערטטינארג",
  "block.minecraft.andesite_stairs": "פערטטיזעדנא",
  "block.minecraft.red_nether_brick_stairs": "ףכרטלגיצ־רעדענ עטיור",
  "block.minecraft.polished_andesite_stairs": "פערטטיזעדנא רעטרילאּפ",
  "block.minecraft.diorite_stairs": "פערטטיגאיד",
  "block.minecraft.polished_granite_slab": "עטאלפטינארג עטרילאּפ",
  "block.minecraft.smooth_red_sandstone_slab": "עטאלפנייטשגמאזטיור עטאלג",
  "block.minecraft.mossy_stone_brick_slab": "עטאלפלגיצנייטש עטכאמאב",
  "block.minecraft.polished_diorite_slab": "עטאלפטיגאיד עטרילאּפ",
  "block.minecraft.mossy_cobblestone_slab": "עטאלפקורב עטכאמאב",
  "block.minecraft.end_stone_brick_slab": "עטאלפלגיצנייטשדנע",
  "block.minecraft.smooth_sandstone_slab": "עטאלפנייטשגמאז עטאלג",
  "block.minecraft.smooth_quartz_slab": "עטאלפצראווק עטאלג",
  "block.minecraft.granite_slab": "עטאלפטינארג",
  "block.minecraft.andesite_slab": "עטאלפטיזעדנא",
  "block.minecraft.red_nether_brick_slab": "עטאלפלגיצ־רעדענ עטיור",
  "block.minecraft.polished_andesite_slab": "עטאלפטיזעדנא עטרילאּפ",
  "block.minecraft.diorite_slab": "עטאלפטיגאיד",
  "block.minecraft.scaffolding": "לעטשעג",
  "block.minecraft.iron_door": "ריטנזַייא",
  "block.minecraft.oak_door": "ריטצלאהנכייא",
  "block.minecraft.spruce_door": "ריטצלאהנענעט",
  "block.minecraft.birch_door": "ריטצלאהעזערעב",
  "block.minecraft.jungle_door": "ריטצלאהלגנושז",
  "block.minecraft.acacia_door": "ריטצלאההנעיצאקא",
  "block.minecraft.dark_oak_door": "ריטצלאהנכייצראווש",
  "block.minecraft.crimson_door": "ריט ןסמאפ",
  "block.minecraft.warped_door": "ריט טשימעצ",
  "block.minecraft.repeater": "רעקראטשראפ־ןאטסדער",
  "block.minecraft.comparator": "ראטאראפמאק־ןאטסדער",
  "block.minecraft.structure_block": "קאלברוטקורטס",
  "block.minecraft.jigsaw": "קאלבדנובראפ",
  "item.minecraft.turtle_helmet": "רעצנאפנטיורקדליש□□:ףאק םפיוא□רעצנאּפ 2+",
  "item.minecraft.scute": "דלישנראה",
  "item.minecraft.iron_shovel": "לפושנזַייא□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 3.5+□טייקדניוושעגספירגנא 3-",
  "item.minecraft.iron_pickaxe": "קאהציפשנזַייא□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 3+□טייקדניוושעגספירגנא 2.8-",
  "item.minecraft.iron_axe": "קאהנזַייא□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 8+□טייקדניוושעגספירגנא 3.1-",
  "item.minecraft.flint_and_steel": "לאטש ןוא ןייטשרעייפ",
  "item.minecraft.apple": "לפע",
  "item.minecraft.bow": "ןגיוב",
  "item.minecraft.arrow": "לַייֿפ",
  "item.minecraft.coal": "ליוק",
  "item.minecraft.charcoal": "ליוקצלאה",
  "item.minecraft.diamond": "טנעמיד",
  "item.minecraft.iron_ingot": "ןעקנאצנזַייא",
  "item.minecraft.gold_ingot": "ןעקנאצדלאג",
  "item.minecraft.netherite_ingot": "ןאראב עטירעהטענ",
  "item.minecraft.netherite_scrap": "ךעלקערב עטירעהטענ",
  "item.minecraft.iron_sword": "דרעוושנזַייא□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 5+□טייקדניוושעגספירגנא 2.4-",
  "item.minecraft.wooden_sword": "דרעוושצלאה□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 3+□טייקדניוושעגספירגנא 2.4-",
  "item.minecraft.wooden_shovel": "לפושצלאה□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 1.5+□טייקדניוושעגספירגנא 3-",
  "item.minecraft.wooden_pickaxe": "קאהציפשצלאה□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 1+□טייקדניוושעגספירגנא 2.8-",
  "item.minecraft.wooden_axe": "קאהצלאה□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 6+□טייקדניוושעגספירגנא 3.2-",
  "item.minecraft.stone_sword": "דרעוושנייטש□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 4+□טייקדניוושעגספירגנא 2.4-",
  "item.minecraft.stone_shovel": "לפושנייטש□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 2.5+□טייקדניוושעגספירגנא 3-",
  "item.minecraft.stone_pickaxe": "קאהציפשנייטש□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 2+□טייקדניוושעגספירגנא 2.8-",
  "item.minecraft.stone_axe": "קאהנייטש□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 8+□טייקדניוושעגספירגנא 3.2-",
  "item.minecraft.diamond_sword": "דרעוושטנעמיד□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 6+□טייקדניוושעגספירגנא 2.4-",
  "item.minecraft.diamond_shovel": "לפושטנעמיד□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 4.5+□טייקדניוושעגספירגנא 3-",
  "item.minecraft.diamond_pickaxe": "קאהציפשטנעמיד□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 4+□טייקדניוושעגספירגנא 2.8-",
  "item.minecraft.diamond_axe": "קאהטנעמיד□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 8+□טייקדניוושעגספירגנא 3-",
  "item.minecraft.stick": "ןקעטש",
  "item.minecraft.bowl": "לסיש",
  "item.minecraft.mushroom_stew": "ףוזלמעווש",
  "item.minecraft.golden_sword": "דרעוושדלאג□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 3+□טייקדניוושעגספירגנא 2.4-",
  "item.minecraft.golden_shovel": "לפושדלאג□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 1.5+□טייקדניוושעגספירגנא 3-",
  "item.minecraft.golden_pickaxe": "קאהציפשדלאג□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 1+□טייקדניוושעגספירגנא 2.8-",
  "item.minecraft.golden_axe": "קאהדלאג□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 6+□טייקדניוושעגספירגנא 3-",
  "item.minecraft.netherite_sword": "דרעווש עטירעהטענ□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 7+□טייקדניוושעגספירגנא 2.4-",
  "item.minecraft.netherite_shovel": "לדיר עטירעהטענ□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 5.5+□טייקדניוושעגספירגנא 3-",
  "item.minecraft.netherite_pickaxe": "קאהקיציפש עטירעהטענ□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 5+□טייקדניוושעגספירגנא 2.8-",
  "item.minecraft.netherite_axe": "קאה עטירעהטענ□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 9+□טייקדניוושעגספירגנא 3-",
  "item.minecraft.string": "םעדאפ",
  "item.minecraft.feather": "רעדעפ",
  "item.minecraft.gunpowder": "רעוולופצראווש",
  "item.minecraft.wooden_hoe": "ןזַייאבארגצלאה□□:טנאהטפיוה רעד ןיא□טייקדניוושעגספירגנא 3-",
  "item.minecraft.stone_hoe": "נייטשןזַייאבארגנייטש□□:טנאהטפיוה רעד ןיא□טייקדניוושעגספירגנא 2-",
  "item.minecraft.iron_hoe": "ןזַייאבארגנזַייא□□:טנאהטפיוה רעד ןיא□טייקדניוושעגספירגנא 1-",
  "item.minecraft.diamond_hoe": "ןזַייאבארגטנעמיד□□:טנאהטפיוה רעד ןיא",
  "item.minecraft.golden_hoe": "ןזַייאבארגדלאג□□:טנאהטפיוה רעד ןיא□טייקדניוושעגספירגנא 3-",
  "item.minecraft.netherite_hoe": "קאהןטראג עטירעהטענ□□:טנאהטפיוה רעד ןיא",
  "item.minecraft.wheat_seeds": "ךעלדנרעקנצייוו",
  "item.minecraft.wheat": "ןצייוו",
  "item.minecraft.bread": "טיורב",
  "item.minecraft.leather_helmet": "םלעהרעדעל□□:ףאק םפיוא□רעצנאּפ 1+",
  "item.minecraft.leather_chestplate": "דמעהרעדעל□□:רעפרעק םפיוא□רעצנאּפ 3+",
  "item.minecraft.leather_leggings": "ןזיוהרעדעל□□:רענייב יד ףיוא□רעצנאּפ 2+",
  "item.minecraft.leather_boots": "לוויטשרעדעל□□:סיפ יד ףיוא□רעצנאּפ 1+",
  "item.minecraft.chainmail_helmet": "םלעהנטייק□□:ףאק םפיוא□רעצנאּפ 2+",
  "item.minecraft.chainmail_chestplate": "דמעהנטייק□□:רעפרעק םפיוא□רעצנאּפ 5+",
  "item.minecraft.chainmail_leggings": "ןזיוהנטייק□□:רענייב יד ףיוא□רעצנאּפ 4+",
  "item.minecraft.chainmail_boots": "לוויטשנטייק□□:סיפ יד ףיוא□רעצנאּפ 1+",
  "item.minecraft.iron_helmet": "םלעהנזַייא□□:ףאק םפיוא□רעצנאּפ 2+",
  "item.minecraft.iron_chestplate": "דמעהנזַייא□□:רעפרעק םפיוא□רעצנאּפ 6+",
  "item.minecraft.iron_leggings": "ןזיוהנזַייא□□:רענייב יד ףיוא□רעצנאּפ 5+",
  "item.minecraft.iron_boots": "לוויטשנזַייא□□:סיפ יד ףיוא□רעצנאּפ 2+",
  "item.minecraft.diamond_helmet": "םלעהטנעמיד□□:ףאק םפיוא□רעצנאּפ 3+□טייקדראהסרעצנאפ 2+",
  "item.minecraft.diamond_chestplate": "דמעהטנעמיד□□:רעפרעק םפיוא□רעצנאּפ 8+□טייקדראהסרעצנאפ 2+",
  "item.minecraft.diamond_leggings": "ןזיוהטנעמיד□□:רענייב יד ףיוא□רעצנאּפ 6+□טייקדראהסרעצנאפ 2+",
  "item.minecraft.diamond_boots": "לוויטשטנעמיד□□:סיפ יד ףיוא□רעצנאּפ 3+□טייקדראהסרעצנאפ 2+",
  "item.minecraft.golden_helmet": "םלעהדלאג□□:ףאק םפיוא□רעצנאּפ 2+",
  "item.minecraft.golden_chestplate": "דמעהדלאג□□:רעפרעק םפיוא□רעצנאּפ 5+",
  "item.minecraft.golden_leggings": "ןזיוהדלאג□□:רענייב יד ףיוא□רעצנאּפ 3+",
  "item.minecraft.golden_boots": "לוויטשדלאג□□:סיפ יד ףיוא□רעצנאּפ 1+",
  "item.minecraft.netherite_helmet": "םלעה עטירעהטענ□□:ףאק םפיוא□רעצנאּפ 3+□טייקדראהסרעצנאפ 3+□דנאטשרעדיוונסיוטשקיר 1+",
  "item.minecraft.netherite_chestplate": "עטאלפטסאשט עטירעהטענ□□:רעפרעק םפיוא□רעצנאּפ 8+□טייקדראהסרעצנאפ 3+□דנאטשרעדיוונסיוטשקיר 1+",
  "item.minecraft.netherite_leggings": "ןזיוה עטירעהטענ□□:רענייב יד ףיוא□רעצנאּפ 6+□טייקדראהסרעצנאפ 3+□דנאטשרעדיוונסיוטשקיר 1+",
  "item.minecraft.netherite_boots": "ךיש עטירעהטענ□□:סיפ יד ףיוא□רעצנאּפ 3+□טייקדראהסרעצנאפ 3+□דנאטשרעדיוונסיוטשקיר 1+",
  "item.minecraft.flint": "ןייטשלזיק",
  "item.minecraft.porkchop": "שיילפנייווש סיור",
  "item.minecraft.cooked_porkchop": "שיילפנייווש סנטארבעג",
  "item.minecraft.painting": "לעמעג",
  "item.minecraft.golden_apple": "לפע רענדליג",
  "item.minecraft.enchanted_golden_apple": "לפעדלאג רעטרעביוצראפ",
  "block.minecraft.oak_sign": "דלישצלאהנכייא",
  "block.minecraft.spruce_sign": "דלישצלאהנענעט",
  "block.minecraft.birch_sign": "דלישצלאהעזערעב",
  "block.minecraft.jungle_sign": "דלישצלאהלגנושז",
  "block.minecraft.acacia_sign": "דלישצלאהנעיצאקא",
  "block.minecraft.dark_oak_sign": "דלישצלאהנכייצראווש",
  "block.minecraft.crimson_sign": "דליש ןסמאפ",
  "block.minecraft.warped_sign": "דליש טשימעצ",
  "item.minecraft.bucket": "רעמע",
  "item.minecraft.water_bucket": "רעמערעסאוו",
  "item.minecraft.lava_bucket": "רעמעעוואל",
  "item.minecraft.minecart": "עניבארד",
  "item.minecraft.saddle": "לטאז",
  "item.minecraft.redstone": "ביוטש־ןאטסדער",
  "item.minecraft.snowball": "לאביינש",
  "item.minecraft.oak_boat": "עקדאלצלאהנכייא",
  "item.minecraft.leather": "רעדעל",
  "item.minecraft.milk_bucket": "רעמעכילמ",
  "item.minecraft.pufferfish_bucket": "רעמעשיפלעווש",
  "item.minecraft.salmon_bucket": "רעמעסקאל",
  "item.minecraft.cod_bucket": "רעמעשראד",
  "item.minecraft.tropical_fish_bucket": "רעמעשיפנפארט",
  "item.minecraft.brick": "ןייטשלגיצ",
  "item.minecraft.clay_ball": "םייל ןופ קיטש",
  "block.minecraft.dried_kelp_block": "קאלבזארג־םי ענקורט",
  "item.minecraft.paper": "ריפאפ",
  "item.minecraft.book": "ךוב",
  "item.minecraft.slime_ball": "לאבמיילש",
  "item.minecraft.chest_minecart": "עניבארדנטסאק",
  "item.minecraft.furnace_minecart": "עניבארדנוויוא",
  "item.minecraft.egg": "ייא",
  "item.minecraft.compass": "סאפמאק",
  "item.minecraft.fishing_rod": "עקטנעוו",
  "item.minecraft.clock": "רעגייז",
  "item.minecraft.glowstone_dust": "ביוטשנייטשטכַייל",
  "item.minecraft.cod": "שראד רעיור",
  "item.minecraft.salmon": "סקאל רעיור",
  "item.minecraft.tropical_fish": "שיפנפארט",
  "item.minecraft.pufferfish": "שיפלעווש",
  "item.minecraft.cooked_cod": "שראד רענטארבעג",
  "item.minecraft.cooked_salmon": "סקאל רענטארבעג",
  "item.minecraft.ink_sac": "לטייבנטניט",
  "item.minecraft.red_dye": "ףאטשבראפ רעטייור",
  "item.minecraft.green_dye": "ףאטשבראפ רענירג",
  "item.minecraft.cocoa_beans": "נעניובאאקאק",
  "item.minecraft.lapis_lazuli": "ןייטשאלב",
  "item.minecraft.purple_dye": "ףאטשבראפאליל",
  "item.minecraft.cyan_dye": "ףאטשבראפזיקרוט",
  "item.minecraft.light_gray_dye": "ףאטשבראפיורגלעה",
  "item.minecraft.gray_dye": "ףאטשבראפיורג",
  "item.minecraft.pink_dye": "ףאטשבראפטיורלעה",
  "item.minecraft.lime_dye": "ףאטשבראפנירגלעה",
  "item.minecraft.yellow_dye": "ףאטשבראפ רעלעג",
  "item.minecraft.light_blue_dye": "ףאטשבראפיולבלעה",
  "item.minecraft.magenta_dye": "ףאטשבראפףאטשבראפאטנעשזדאמ",
  "item.minecraft.orange_dye": "ףאטשבראפשזנארא",
  "item.minecraft.bone_meal": "לעמנייב",
  "item.minecraft.blue_dye": "ףאטשבראפ רעיולב",
  "item.minecraft.brown_dye": "ףאטשבראפ רענייורב",
  "item.minecraft.black_dye": "ףאטשבראפ רעצראווש",
  "item.minecraft.white_dye": "ףאטשבראפ רעסייוו",
  "item.minecraft.bone": "ןכאנק",
  "item.minecraft.sugar": "רעקוצ",
  "block.minecraft.cake": "עקבאב",
  "block.minecraft.white_bed": "טעב ססַייוו",
  "block.minecraft.orange_bed": "טעב סשזנארא",
  "block.minecraft.magenta_bed": "טעב סאטנעשזדאמ",
  "block.minecraft.light_blue_bed": "טעב סיולבלעה",
  "block.minecraft.yellow_bed": "טעב סלעג",
  "block.minecraft.lime_bed": "טעב סנירגלעה",
  "block.minecraft.pink_bed": "טעב סטיורלעה",
  "block.minecraft.gray_bed": "טעב סיורג",
  "block.minecraft.light_gray_bed": "טעב סיורגלעה",
  "block.minecraft.cyan_bed": "טעב סזיקרוט",
  "block.minecraft.purple_bed": "טעב סאליל",
  "block.minecraft.blue_bed": "טעב סיולב",
  "block.minecraft.brown_bed": "טעב סניורב",
  "block.minecraft.green_bed": "טעב סנירג",
  "block.minecraft.red_bed": "טעב סטיור",
  "block.minecraft.black_bed": "טעב סצראווש",
  "item.minecraft.cookie": "לכיק",
  "item.minecraft.filled_map": "עפאמ□#0",
  "item.minecraft.shears": "ןרעש",
  "item.minecraft.melon_slice": "ביושנענאלעמ",
  "item.minecraft.dried_kelp": "זארג־םי סנקורט",
  "item.minecraft.pumpkin_seeds": "ךעלדנרעקסעבריק",
  "item.minecraft.melon_seeds": "ךעלדנרעקנענאלעמ",
  "item.minecraft.beef": "שיילפדניר סעיור",
  "item.minecraft.cooked_beef": "שיילפדניר סנטארבעג",
  "item.minecraft.chicken": "שיילפרעניה סיור",
  "item.minecraft.cooked_chicken": "שיילפרעניה סנטארבעג",
  "item.minecraft.rotten_flesh": "שיילפ סטליופראפ",
  "item.minecraft.ender_pearl": "לרעפרעדנע",
  "item.minecraft.blaze_rod": "באטשנזואט",
  "item.minecraft.ghast_tear": "רערט־טסאג",
  "item.minecraft.gold_nugget": "ףמולקדלאג",
  "item.minecraft.nether_wart": "סעקוועדארב־רעדענ",
  "item.minecraft.potion": "קנורט רעראביורבמוא□זאלגנוקריוו",
  "item.minecraft.glass_bottle": "שאלפזאלג",
  "item.minecraft.spider_eye": "גיונעניפש",
  "item.minecraft.fermented_spider_eye": "גיונעניפש סנריויעג",
  "item.minecraft.blaze_powder": "ביוטשנזואט",
  "item.minecraft.magma_cream": "םערקעמגאמ",
  "block.minecraft.brewing_stand": "דנאטשיורב",
  "block.minecraft.cauldron": "לסעק",
  "item.minecraft.ender_eye": "גיורעדנע",
  "item.minecraft.glistering_melon_slice": "ביושנענאלעמ עקידלצנעלג",
  "item.minecraft.bat_spawn_egg": "ייא־יזשדימאב־זיומרעדעלֿפ",
  "item.minecraft.bee_spawn_egg": "קאלב במאקיינאה",
  "item.minecraft.blaze_spawn_egg": "ייא־יזשדימאב־נזואט",
  "item.minecraft.cat_spawn_egg": "ייא־יזשדימאב־ץאק",
  "item.minecraft.cave_spider_spawn_egg": "ייא־יזשדימאב־ניּפשנלייה",
  "item.minecraft.chicken_spawn_egg": "ייא־יזשדימאב־נוה",
  "item.minecraft.cod_spawn_egg": "ייא־יזשדימאב־שראד",
  "item.minecraft.cow_spawn_egg": "ייא־יזשדימאב־וק",
  "item.minecraft.creeper_spawn_egg": "ייא־יזשדימאב־רעּפירק",
  "item.minecraft.dolphin_spawn_egg": "ייא־יזשדימאב־ניֿפלעד",
  "item.minecraft.donkey_spawn_egg": "ייא־יזשדימאב־לזייא",
  "item.minecraft.drowned_spawn_egg": "ייא־יזשדימאב־ןענעקנורטרעד",
  "item.minecraft.elder_guardian_spawn_egg": "ייא־יזשדימאב־עראזאדסיורג",
  "item.minecraft.enderman_spawn_egg": "ייא־יזשדימאב־נאמרעדנע",
  "item.minecraft.endermite_spawn_egg": "ייא־יזשדימאב־ןטימרעדנע",
  "item.minecraft.evoker_spawn_egg": "ייא־יזשדימאב־רעפורסיוא",
  "item.minecraft.fox_spawn_egg": "ייא־יזשדימאב־סקאפ",
  "item.minecraft.ghast_spawn_egg": "ייא־יזשדימאב־טסאג",
  "item.minecraft.guardian_spawn_egg": "ייא־יזשדימאב־עראזאד",
  "item.minecraft.hoglin_spawn_egg": "ייא יזשדימאב ןילגאה",
  "item.minecraft.horse_spawn_egg": "ייא־יזשדימאב־דרעפ",
  "item.minecraft.husk_spawn_egg": "ייא־יזשדימאב־קינרבדימ",
  "item.minecraft.llama_spawn_egg": "ייא־יזשדימאב־עמאל",
  "item.minecraft.magma_cube_spawn_egg": "ייא־יזשדימאב־לפרעוועמגאמ",
  "item.minecraft.mooshroom_spawn_egg": "ייא־יזשדימאב־םורשומ",
  "item.minecraft.mule_spawn_egg": "ייא־יזשדימאב־לזייאליומ",
  "item.minecraft.ocelot_spawn_egg": "ייא־יזשדימאב־טאלעצא",
  "item.minecraft.panda_spawn_egg": "אדנאּפ יי גיור",
  "item.minecraft.parrot_spawn_egg": "ייא־יזשדימאב־ייגופאפ",
  "item.minecraft.phantom_spawn_egg": "ייא־יזשדימאב־חור",
  "item.minecraft.pig_spawn_egg": "ייא־יזשדימאב־ןייווש",
  "item.minecraft.piglin_spawn_egg": "ייא יזשדימאב ןילגיפ",
  "item.minecraft.pillager_spawn_egg": "רעגאלליּפ יי גיור",
  "item.minecraft.polar_bear_spawn_egg": "ייא־יזשדימאב־רעבזייא",
  "item.minecraft.pufferfish_spawn_egg": "ייא־יזשדימאב־שיפלעווש",
  "item.minecraft.rabbit_spawn_egg": "ייא־יזשדימאב־לגיניק",
  "item.minecraft.ravager_spawn_egg": "ןכאמ וועראכ יי גיור",
  "item.minecraft.salmon_spawn_egg": "ייא־יזשדימאב־סקאל",
  "item.minecraft.sheep_spawn_egg": "ייא־יזשדימאב־ףאש",
  "item.minecraft.shulker_spawn_egg": "ייא־יזשדימאב־רעקלוש",
  "item.minecraft.silverfish_spawn_egg": "ייא־יזשדימאב־לשיפרעבליז",
  "item.minecraft.skeleton_spawn_egg": "ייא־יזשדימאב־טעלעקס",
  "item.minecraft.skeleton_horse_spawn_egg": "ייא־יזשדימאב־דרעפטעלעקס",
  "item.minecraft.slime_spawn_egg": "ייא־יזשדימאב־םיילש",
  "item.minecraft.spider_spawn_egg": "ייא־יזשדימאב־ןעניפש",
  "item.minecraft.squid_spawn_egg": "ייא־יזשדימאב־שיפטניט",
  "item.minecraft.stray_spawn_egg": "ייא־יזשדימאב־רערעדנאווזייא",
  "item.minecraft.strider_spawn_egg": "ייא יזשדימאב רעדירטס",
  "item.minecraft.trader_llama_spawn_egg": "אמאל רעדיירט יי גיור",
  "item.minecraft.tropical_fish_spawn_egg": "ייא־יזשדימאב־שיפנפארט",
  "item.minecraft.turtle_spawn_egg": "ייא־יזשדימאב־ןטיורקדליש",
  "item.minecraft.vex_spawn_egg": "ייא־יזשדימאב־ובמוקס",
  "item.minecraft.villager_spawn_egg": "ייא־יזשדימאב־רעניווונַייֿפרעד",
  "item.minecraft.vindicator_spawn_egg": "ייא־יזשדימאב־רעניד",
  "item.minecraft.wandering_trader_spawn_egg": "רעדיירט גנירעדנאוו יי גיור",
  "item.minecraft.witch_spawn_egg": "ייא־יזשדימאב־הֿפשכמ",
  "item.minecraft.wither_skeleton_spawn_egg": "ייא־יזשדימאב־טעלעקס־רעדיוו",
  "item.minecraft.wolf_spawn_egg": "ייא־יזשדימאב־ףלאוו",
  "item.minecraft.zoglin_spawn_egg": "ייא יזשדימאב ןילגאז",
  "item.minecraft.zombie_spawn_egg": "ייא־יזשדימאב־יבמאז",
  "item.minecraft.zombie_horse_spawn_egg": "ייא־יזשדימאב־דרעֿפיבמאז",
  "item.minecraft.zombie_villager_spawn_egg": "ייא־יזשדימאב־רעניווונַייֿפראדיבמאז",
  "item.minecraft.zombified_piglin_spawn_egg": "ייא יזשדימאב ןילגיפ יבמאז",
  "item.minecraft.experience_bottle": "לשעלפסגנוראפרעד",
  "item.minecraft.fire_charge": "לאברעייפ",
  "item.minecraft.writable_book": "רעדעפ ןוא ךוב",
  "item.minecraft.written_book": "ךוב סנבירשאב",
  "item.minecraft.emerald": "קאראמש",
  "item.minecraft.item_frame": "םארדנאטשנגעג",
  "block.minecraft.flower_pot": "ףאטנמולב",
  "item.minecraft.carrot": "רעמ",
  "item.minecraft.potato": "לפאטראק",
  "item.minecraft.baked_potato": "ןפלאטראקנוויוא",
  "item.minecraft.poisonous_potato": "לפאטראק עקיטפיג",
  "item.minecraft.map": "עטראק ערעל",
  "item.minecraft.golden_carrot": "רעמדלאג",
  "block.minecraft.skeleton_skull": "לדיישטעלעקס",
  "block.minecraft.wither_skeleton_skull": "לדיישטעלעקס־רעדיוו",
  "block.minecraft.player_head": "ףאקרעליפס",
  "block.minecraft.zombie_head": "ףאקיבמאז",
  "block.minecraft.creeper_head": "ףאקרעפירק",
  "block.minecraft.dragon_head": "ףאקסנאקארד",
  "item.minecraft.carrot_on_a_stick": "טוררעמ",
  "item.minecraft.warped_fungus_on_a_stick": "טור למעווש טשימעצ",
  "item.minecraft.nether_star": "ןרעטשרעדענ",
  "item.minecraft.pumpkin_pie": "ןכוקסעבריק",
  "item.minecraft.firework_rocket": "טעקארסקרעוורעייפ",
  "item.minecraft.firework_star": "ןרעטשסקרעוורעייפ",
  "item.minecraft.enchanted_book": "ךוב סטרעביוצראפ",
  "item.minecraft.nether_brick": "לגיצרעדענ",
  "item.minecraft.quartz": "ץראווקרעדענ",
  "item.minecraft.tnt_minecart": "עניבארדטימאניד",
  "item.minecraft.hopper_minecart": "עניבארדעקייל",
  "item.minecraft.prismarine_shard": "לברעשניראמסירּפ",
  "item.minecraft.prismarine_crystals": "ןלאטשירקניראמסירּפ",
  "item.minecraft.rabbit": "שיילפקילארק סיור",
  "item.minecraft.cooked_rabbit": "שיילפקילארק סנטארבעג",
  "item.minecraft.rabbit_stew": "וגארנזאה",
  "item.minecraft.rabbit_foot": "סופנזאה",
  "item.minecraft.rabbit_hide": "לעפנזאה",
  "item.minecraft.armor_stand": "דנאטשרעצנאפ",
  "item.minecraft.iron_horse_armor": "רעצנאפדרעפנזַייא",
  "item.minecraft.golden_horse_armor": "רעצנאפדרעפדלאג",
  "item.minecraft.diamond_horse_armor": "רעצנאפדרעפטנעמיד",
  "item.minecraft.leather_horse_armor": "רעצנאפדרעפרעדעל",
  "item.minecraft.lead": "עילטעפ",
  "item.minecraft.name_tag": "דלישסנעמאנ",
  "item.minecraft.command_block_minecart": "עניבארדקאלבסלעֿפאב",
  "item.minecraft.mutton": "שיילפנפאש סיור",
  "item.minecraft.cooked_mutton": "שיילפנפאש סנטארבעג",
  "block.minecraft.white_banner": "ןאפ עסייוו",
  "block.minecraft.orange_banner": "ןאפ עשזנארא",
  "block.minecraft.magenta_banner": "ןאפ עאטנעשזדאמ",
  "block.minecraft.light_blue_banner": "ןאפ עיולבלעה",
  "block.minecraft.yellow_banner": "ןאפ עלעג",
  "block.minecraft.lime_banner": "ןאפ ענירגלעה",
  "block.minecraft.pink_banner": "ןאפ עטיורלעה",
  "block.minecraft.gray_banner": "ןאפ עיורג",
  "block.minecraft.light_gray_banner": "ןאפ עיורגלעה",
  "block.minecraft.cyan_banner": "ןאפ עזיקרוט",
  "block.minecraft.purple_banner": "ןאפ עאליל",
  "block.minecraft.blue_banner": "ןאפ עיולב",
  "block.minecraft.brown_banner": "ןאפ עניורב",
  "block.minecraft.green_banner": "ןאפ ענירג",
  "block.minecraft.red_banner": "ןאפ עטיור",
  "block.minecraft.black_banner": "ןאפ עצראווש",
  "item.minecraft.end_crystal": "לאטשירקדנע",
  "item.minecraft.chorus_fruit": "ספיוראכראכ",
  "item.minecraft.popped_chorus_fruit": "טכורפראכ עצאלפעג",
  "item.minecraft.beetroot": "קיווצ",
  "item.minecraft.beetroot_seeds": "סנעמיוזסעקיווצ",
  "item.minecraft.beetroot_soup": "טשראב",
  "item.minecraft.dragon_breath": "םעטאנאקארד",
  "item.minecraft.splash_potion": "קנורטפראוו רעראביורבמוא□זאלגנוקריוו",
  "item.minecraft.spectral_arrow": "לַייֿפלארטקעפס",
  "item.minecraft.tipped_arrow": "לייפ עקנוטעג רעראבכאממוא□זאלגנוקריוו",
  "item.minecraft.lingering_potion": "קנורטלייווראפ רעראביורבמוא□זאלגנוקריוו",
  "item.minecraft.shield": "דליש",
  "item.minecraft.elytra": "ערטילע",
  "item.minecraft.spruce_boat": "עקדאלצלאהנענעט",
  "item.minecraft.birch_boat": "עקדאלצלאהעזערעב",
  "item.minecraft.jungle_boat": "עקדאלצלאהלגנושז",
  "item.minecraft.acacia_boat": "עקדאלעקדאלצלאההנעיצאקא",
  "item.minecraft.dark_oak_boat": "עקדאלצלאהנכייצראווש",
  "item.minecraft.totem_of_undying": "טייקכעלבראטשמוא רעד ןופ םעטאט",
  "item.minecraft.shulker_shell": "לאשרעקלוש",
  "item.minecraft.iron_nugget": "ףמולקנזייא",
  "item.minecraft.knowledge_book": "ךובסנסיוו",
  "item.minecraft.debug_stick": "באטש־גאביד",
  "item.minecraft.music_disc_13": "עטאלפלאש□c418 - 13",
  "item.minecraft.music_disc_cat": "עטאלפלאש□c418 - cat",
  "item.minecraft.music_disc_blocks": "עטאלפלאש□c418 - blocks",
  "item.minecraft.music_disc_chirp": "עטאלפלאש□c418 - chirp",
  "item.minecraft.music_disc_far": "עטאלפלאש□c418 - far",
  "item.minecraft.music_disc_mall": "עטאלפלאש□c418 - mall",
  "item.minecraft.music_disc_mellohi": "עטאלפלאש□c418 - mellohi",
  "item.minecraft.music_disc_stal": "עטאלפלאש□c418 - stal",
  "item.minecraft.music_disc_strad": "עטאלפלאש□c418 - strad",
  "item.minecraft.music_disc_ward": "עטאלפלאש□c418 - ward",
  "item.minecraft.music_disc_11": "עטאלפלאש□c418 - 11",
  "item.minecraft.music_disc_wait": "עטאלפלאש□c418 - wait",
  "item.minecraft.music_disc_pigstep": "עטאלפלאש□pigstep - ענייר אנעל",
  "item.minecraft.trident": "קאציירד□□:טנאהטפיוה רעד ןיא□ןדאשספירגנא 8+□טייקדניוושעגספירגנא 2.9-",
  "item.minecraft.phantom_membrane": "לטייהמאטנאפ",
  "item.minecraft.nautilus_shell": "לאשסוליטואנ",
  "item.minecraft.heart_of_the_sea": "ץרעה־םי",
  "item.minecraft.crossbow": "טסורבמרא",
  "item.minecraft.suspicious_stew": "ּפוז עקידמידשח",
  "block.minecraft.loom": "לוטשבעוו",
  "item.minecraft.flower_banner_pattern": "גאלראפנאפ□םעראפנמולב",
  "item.minecraft.creeper_banner_pattern": "גאלראפנאפ□םעראפסרעפירק",
  "item.minecraft.skull_banner_pattern": "גאלראפנאפ□םעראפלדייש",
  "item.minecraft.mojang_banner_pattern": "גאלראפנאפ□לּפמעטש",
  "item.minecraft.globe_banner_pattern": "ןאפ□סובאלג",
  "item.minecraft.piglin_banner_pattern": "גאלראפנאפ□קונש",
  "block.minecraft.composter": "רעטסאפמאק",
  "block.minecraft.barrel": "סאפ",
  "block.minecraft.smoker": "ןוויורעכיור",
  "block.minecraft.blast_furnace": "ןוויוצלעמש",
  "block.minecraft.cartography_table": "שיטנטראק",
  "block.minecraft.fletching_table": "שיטרענגיוב",
  "block.minecraft.grindstone": "ןייטשפיילש",
  "block.minecraft.lectern": "רעדנעטש",
  "block.minecraft.smithing_table": "שיטדימש",
  "block.minecraft.stonecutter": "געזנייטש",
  "block.minecraft.bell": "קאלג",
  "block.minecraft.lantern": "ןרעטמאל",
  "block.minecraft.soul_lantern": "ןרעטנאל המשנ",
  "item.minecraft.sweet_berries": "סעדגאיסיז",
  "block.minecraft.campfire": "רעייפרעגאל",
  "block.minecraft.soul_campfire": "עריפפמאק המשנ",
  "block.minecraft.shroomlight": "טכילםאארש",
  "item.minecraft.honeycomb": "טאס",
  "block.minecraft.bee_nest": "טסענניב",
  "block.minecraft.beehive": "קאטשניב",
  "item.minecraft.honey_bottle": "שאלֿפקינאה",
  "block.minecraft.honey_block": "קאלב קינאה",
  "block.minecraft.honeycomb_block": "קאלב במאקיינאה",
  "block.minecraft.lodestone": "ןייטשעדאל",
  "block.minecraft.netherite_block": "קאלב עטירעהטענ",
  "block.minecraft.ancient_debris": "ךערביוב עטלא",
  "block.minecraft.target": "קאלב ליצ",
  "block.minecraft.crying_obsidian": "ןאידיסבא ןייוועג",
  "block.minecraft.blackstone": "ןייטשצראווש",
  "block.minecraft.blackstone_slab": "עטאלפנייטשצראווש",
  "block.minecraft.blackstone_stairs": "ףערטנייטשצראווש",
  "block.minecraft.gilded_blackstone": "ןייטשצראווש ססארקסירק-דלאג",
  "block.minecraft.polished_blackstone": "ןייטשצראווש טשילאפ",
  "block.minecraft.polished_blackstone_slab": "עטאלפנייטשצראווש טשילאפ",
  "block.minecraft.polished_blackstone_stairs": "ףערטנייטשצראווש טשילאפ",
  "block.minecraft.chiseled_polished_blackstone": "ןייטשצראווש טשילאפ רעטריווארג",
  "block.minecraft.polished_blackstone_bricks": "לגיצנייטשצראווש טשילאפ",
  "block.minecraft.polished_blackstone_brick_slab": "עטאלפלגיצנייטשצראווש טשילאפ",
  "block.minecraft.polished_blackstone_brick_stairs": "ףערטלגיצנייטשצראווש טשילאפ",
  "block.minecraft.cracked_polished_blackstone_bricks": "לגיצנייטשצראווש טשילאפ טקארק",
  "block.minecraft.respawn_anchor": "רעקנא ןוואפסער",
}
export const yi_de = items; 
